<div class="preview-form-grid">
  <div *ngIf="activeIndex$ | async as index">
    <ul
      class="form-stepper"
      *ngIf="renderedFormService.visibleSections && renderedFormService.visibleSections.length > 1"
    >
      <li
        *ngFor="let section of renderedFormService.visibleSections; let sectionIndex = index"
        [class.active]="index.position === sectionIndex"
        class="step"
      >
        <div class="number"></div>
        <div class="title">
          {{ section.title || section.subtitle || "-" }}
        </div>
        <div class="divider"></div>
      </li>
    </ul>
  </div>
  <fl-rendered-form
    [form]="form"
    (flBack)="onBack($event)"
    (flNext)="onNext($event)"
    (flSubmit)="onSubmit()"
    *ngIf="form$ | async as form"
  ></fl-rendered-form>
</div>
